import { mapGetters, mapState } from "vuex";

export const handleDataLayer = {
  data() {
    return {x: 0};
  },
  computed: {
    ...mapState(["resumeData"]),
    ...mapGetters({
      getEngine: "enginesData/getFullEngineByID",
      getVersion: "versionsData/getVersionById",
    }),
  },
  methods: {
    setDataLayerInitCfg() {
      const resumeData = this.resumeData;
      const obj = {
        idModel: resumeData.modelid,
        model: resumeData.model,
        event: "initConfig",
      };

      window.dataLayer?.push(obj);
    },
    setDataLayerEndCfg() {
      const resumeData = this.resumeData;
      const obj = {
        idModel: resumeData.modelid,
        model: resumeData.model,
        exteriorColor: resumeData.configSelected?.dsgExt?.designation,
        interiorColor: resumeData.configSelected?.dsgInt?.designation,
        price: resumeData.basePrice,
        event: "endConfiguration",
      };

      window.dataLayer?.push(obj);
    },
    setDataLayerStepSelection(step) {
      const resumeData = this.resumeData;
      const engine = this.getEngine(resumeData.selectedEngine);
      const version = this.getVersion(resumeData.versionID);
      let obj = {};

      switch (step) {
        case 1:
          obj = {
            idModel: resumeData.modelid,
            model: resumeData.model,
            motor: engine.designation,
            transmission: engine.transmission,
            fuel: engine.fuel,
            price: parseInt(engine.price),
            event: "chooseMotor",
          };
          break;

        case 2:
          obj = {
            idModel: resumeData.modelid,
            model: resumeData.model,
            version: version.designation,
            transmission: version.transmission,
            fuel: version.fuel,
            price: parseInt(version.price),
            event: "chooseVersion",
          };
          break;

        case 3:
          obj = {
            idModel: resumeData.modelid,
            model: resumeData.model,
            exteriorColor: resumeData.configSelected?.dsgExt?.designation,
            event: "chooseExtColor",
          };
          break;

        case 4:
          obj = {
            idModel: resumeData.modelid,
            model: resumeData.model,
            interiorColor: resumeData.configSelected?.dsgInt?.designation,
            event: "chooseIntColor",
          };
          break;
      }

      window.dataLayer?.push(obj);
    },
  },
};
